



























import { Component, Vue, Watch } from "vue-property-decorator";
import { Circle2 } from "vue-loading-spinner";

import EspressoAux from "@/components/Espresso/EspressoAux.vue"
import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";

import bankingFileModel from "@/models/bankingFile.model";

@Component({
	components: {
		PaginatedSearch,
		Circle2,
	},
})
export default class BankingFiles extends Vue {
	entityModel: any;

	searchActions = [
		{ name: 'Download', icon: 'get_app', color: '#0C4DA2', action: this.downloadBankingFile },
		{ name: 'Excluir arquivo', icon: 'delete', color: '#d32f2f', action: this.deleteBankingFile },
	];

	constructor() {
		super();
		this.entityModel = bankingFileModel;
	}

	fileField: any = null;
	fileContents: any;

	async fileSelected(fileList: FileList) {
		if (!fileList.length) {
			return;
		}
		const file = fileList[0];
		const fileReader = new FileReader();
		fileReader.onload = (readerEvent) => {
			this.fileContents = readerEvent?.target?.result;
		};
		fileReader.onerror = (readerEvent) => console.error('File reader error', readerEvent);
		fileReader.readAsText(file, "ISO-8859-1");
	}

	uploading = false;
	processResults: any = null;
	async sendBankingFile() {
		if (!this.fileContents) {
			return this.$toasted.error("Arquivo não carregado");
		}
		this.uploading = true;
		try {
			this.processResults = await bankingFileModel.processBankingFile(this.fileContents);
			this.$toasted.success("Arquivo bancário processado com sucesso");
			this.fileField = null;
		} catch (error) {
			this.$toasted.error("Erro ao processar arquivo bancário");
			console.error(error);
		}
		this.uploading = false;
	}

	async deleteBankingFile(bankingFile: any) {
		const remittanceNumber = bankingFile.remittanceNumber || bankingFile.id;
		if (!(await EspressoAux.showConfirmationModal(`Excluir arquivo ${remittanceNumber}?`, "Plantões e folhas não pagos voltarão para a fila de remessa.")).value) {
			return;
		}
		try {
			await bankingFileModel.deleteBankingFile(bankingFile.id);
			this.$toasted.success("Arquivo excluído com sucesso");
			(this.$refs.bankingFilesSearch as any).refresh();
		} catch (error) {
			this.$toasted.error(error?.message || "Não foi possível excluir o arquivo");
		}
	}

	async downloadBankingFile(bankingFile: any) {
		const cnabInfo = await bankingFileModel.getCnab(bankingFile.id);
		bankingFileModel.downloadCnab({ ...cnabInfo, remittanceNumber: cnabInfo.remittanceNumber || bankingFile.remittanceNumber });
	}
}
